import script from "./Cover.vue?vue&type=script&setup=true&lang=js"
export * from "./Cover.vue?vue&type=script&setup=true&lang=js"

import "./Cover.vue?vue&type=style&index=0&id=f2da7fb8&lang=sass&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2da7fb8"]])

export default __exports__